import React from 'react';
import { Container, Typography } from '@mui/material';

const Application = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Loan Application
      </Typography>
      <Typography variant="body1">
        Multi-step application form (similar to financing-app) will be implemented here.
      </Typography>
    </Container>
  );
};

export default Application;
